export default {
  STEPS: 'paradas',
  OFFER_DISTANCE: distance => `Retirada a ${distance} de você!`,
  UP_TO: 'Até',
  ACTION: 'Retirar',
  WINDOW: 'até',
  LOGGI: 'Loggi',
  LOAD_OFFER_ERROR: 'Não foi possível carregar a oferta'
};
